import React, { useContext } from "react";
import { ApplicationContext } from "@context/ApplicationContext";
import BellIcon from "@components/Icons/BellIcon";
import "./style.scss";

const NoPublicAccess = () => {
    const { whiteLabel } = useContext(ApplicationContext);

    const brand = whiteLabel ? whiteLabel.no_public_access_title : "Something Went Wrong";
    const bodyText = whiteLabel ? whiteLabel.no_public_access_body : "We encountered an error connecting you to your movie rewards. Try refreshing the page or retracing your steps.\n\n";
    const buttonValue = whiteLabel ? whiteLabel.no_public_access_link_value : "Refresh the page";
    const buttonLink = whiteLabel ? whiteLabel.no_public_access_link_url : "/";

	return (
    <>
        <div className="no-access__image-wrapper">
            <BellIcon className="no-access__image" />
        </div>

        <div className="no-access__wrapper">
            <h1 className="no-access__title">{brand}</h1>
            <p className="no-access__text paragraph">
                {bodyText}
            </p>
            {whiteLabel?.no_public_access_link_url && (
            <a className="button button__primary no-access__button" href={buttonLink} target="_blank" rel="noreferrer">
                {buttonValue}
            </a>
                )}
        </div>


    </>
	);
};

export default NoPublicAccess;
